import { useState, useEffect } from "react";
import DSBox from "../../views/system-design/DSBox";
import DSTypography from "../../views/system-design/DSTypography";
import DSTextField from "../../views/system-design/DSTextField";

const SimpleTimePicker = (props: {
  title: string;
  onChange: (e: any) => void;
  default: string;
}) => {
  const parseTime = () => {
    const parts = props?.default?.split(":");
    return (
      parts && `${parts[0].padStart(2, "0")}:${parts[1]?.padStart(2, "0")}`
    );
  };
  const [time, setTime] = useState(() => parseTime());

  useEffect(() => {
    setTime(parseTime());
  }, [props.default]);

  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <DSTypography sx={{ fontWeight: 700 }}>{props.title}</DSTypography>
      <DSTextField
        size="small"
        value={time}
        type="time"
        onChange={(e) => {
          props.onChange(e);
          setTime(e.target.value);
        }}
      />
    </DSBox>
  );
};

export default SimpleTimePicker;
